import { OrgScopedPathPatterns } from '@/routes/orgScopedPathPatterns'
import { matchPath } from 'react-router-dom'

type PathOrganizationScope = 'missing-org' | 'scoped' | null
const pathCache = new Map<string, PathOrganizationScope>()

function isUnmatchedInternalPath(path: string) {
  return matchPath('/internal/*', path) !== null
}

function _getPathOrganizationScope(path: string): PathOrganizationScope {
  if (matchPath('/analysis/:analysisId', path) !== null) {
    return null
  }

  for (const pattern of OrgScopedPathPatterns) {
    if (matchPath(pattern, path) !== null) {
      return 'missing-org'
    }
  }

  if (isUnmatchedInternalPath(path)) {
    return null
  }

  for (const pattern of OrgScopedPathPatterns) {
    if (matchPath(`/:org_slug${pattern}`, path) !== null) {
      return 'scoped'
    }
  }

  return null
}

export function getPathOrganizationScope(path: string): PathOrganizationScope {
  const cached = pathCache.get(path)
  if (cached !== undefined) {
    return cached
  }

  const result = _getPathOrganizationScope(path)
  pathCache.set(path, result)
  return result
}
